// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exchange-footer-apps[data-v-950380aa]{display:flex;grid-gap:1rem;gap:1rem}@media(min-width:992px){.exchange-footer-apps[data-v-950380aa]{flex-direction:column}}.exchange-footer-apps__link[data-v-950380aa]{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
